import { useEffect, useState } from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/store';
import LoginPage from './auth/LoginPage';
import { AboutDialog, ResearchUseBanner, ResearchUseGate } from './compliance/ResearchUse';
import GalleryPage from './gallery/GalleryPage';
import ProjectPage from './gallery/ProjectPage';
import TheaterPage from './theater/TheaterPage';

export default function App() {
  const status = useAuth((s) => s.status);
  const refresh = useAuth((s) => s.refresh);
  useEffect(() => {
    void refresh();
  }, [refresh]);

  if (status === 'unknown') return <div className="centered muted">Loading…</div>;
  if (status === 'anonymous')
    return (
      <div className="app">
        <LoginPage />
        <ResearchUseBanner />
      </div>
    );
  return (
    <ResearchUseGate>
      <Shell />
    </ResearchUseGate>
  );
}

function Shell() {
  const location = useLocation();
  const inTheater = location.pathname.startsWith('/runs/');
  return (
    <div className={inTheater ? 'app app-theater' : 'app'}>
      <TopBar />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<GalleryPage />} />
          <Route path="/projects/:projectId" element={<ProjectPage />} />
          <Route path="/runs/:runId" element={<TheaterPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <ResearchUseBanner />
    </div>
  );
}

function TopBar() {
  const me = useAuth((s) => s.me);
  const logout = useAuth((s) => s.logout);
  const [about, setAbout] = useState(false);
  return (
    <header className="topbar">
      <Link to="/" className="brand" title="Valvia">
        <img src="/logo-wordmark.png" alt="Valvia" />
      </Link>
      <span className="muted small version">v{me?.app_version}</span>
      <span className="spacer" />
      <span className="muted small topbar-user">{me?.user.email}</span>
      <button className="link" onClick={() => setAbout(true)}>
        About
      </button>
      <button className="link" onClick={() => void logout()}>
        Sign out
      </button>
      {about && <AboutDialog onClose={() => setAbout(false)} />}
    </header>
  );
}
